import React from 'react';
import  '../../styles/portfolio.css';
import codingPhoto from '../../photos/coding-img.png';
import hobbyPhoto from '../../photos/hobby.png';
function AboutMeRightHeader(props) {
    return (
        <div className='about-me-header-right'>
            {props.sectionType==='hobby' ?
           <img src ={hobbyPhoto} alt='unable to load img' className='portfolio-img-right'/>
            :<img src ={codingPhoto} alt='unable to load img' className='portfolio-img-right'/>
            }
            <div className='description-right'>
                <h4>{props.title}</h4>
                <div className='sub-description-right'>
                    <p>{props.desc1}{props.sectionType && <a href='https://www.youtube.com/channel/UCyLnz8iPDeZ9CtzT5iPKdDg' className='project-links'> Watch Here</a>}</p>
                    <p>{props.desc2}</p>
                    <p>{props.desc3}{props.sectionType && <a href='/drawings' className='project-links'> Take a Look</a>}</p>   
                </div>
            </div>
        </div>
    );
}

export default AboutMeRightHeader;